import { Badge } from "@/components/ui/badge";
import { statusKontrak } from "@/lib/dates";

export const statusTone = (s) => {
  const v = (s || "").toUpperCase();
  if (v === "AKTIF") return "bg-emerald-50 text-emerald-700 border-emerald-200";
  if (v === "PENSIUN") return "bg-amber-50 text-amber-700 border-amber-200";
  if (v === "RESIGN") return "bg-slate-100 text-slate-700 border-slate-200";
  if (v === "PHK") return "bg-rose-50 text-rose-700 border-rose-200";
  return "bg-slate-100 text-slate-600 border-slate-200";
};

// Badge status kontrak pekerja (kontrak habis/pensiun dsb) — null bila tidak ada info
export function KontrakBadge({ worker, usiaPensiun, testid }) {
  const sk = statusKontrak(worker, usiaPensiun);
  if (!sk) return <span className="text-slate-400">-</span>;
  return (
    <span data-testid={testid}>
      <Badge variant="outline" className={`${sk.className} font-medium`}>{sk.label}</Badge>
    </span>
  );
}
